import React from 'react';

const SwitchContext = React.createContext();

const show = (match, value) => {
    return typeof match === "function" ? match(value) : match === value
};

const Case = ({match, children}) => (
    <SwitchContext.Consumer>
        {value => show(match, value) ? children : null}
    </SwitchContext.Consumer>

);

const Switch = ({value, children}) => (
        <SwitchContext.Provider value={value}>
            {children}
        </SwitchContext.Provider>
);

export { Switch, Case };



// WEBPACK FOOTER //
// ./src/view/Switch.js